document.addEventListener("DOMContentLoaded", function() {
  const sliderElement = document.querySelector(".Index_object_testimonials_slider");

  if (!sliderElement || typeof Swiper === "undefined") {
    return;
  }

  const indexObjectTestimonialsSlider = new Swiper(sliderElement, {
    slidesPerView: "auto",
    spaceBetween: 12,
    direction: "horizontal",
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      0: {
        spaceBetween: 16,
      },
      750: {
        spaceBetween: 12,
      }
    }
  });
});
